import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="section-pad bg-[#FFD600] relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 dot-bg opacity-30 [mask-image:radial-gradient(ellipse_at_center,_black_30%,_transparent_75%)]" />
      <div className="container-secqre relative">
        <div className="max-w-3xl">
          <h2 className="font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95]" data-testid="cta-heading">
            Your privacy is one sticker away.
          </h2>
          <p className="mt-6 text-lg text-[#0A0A0A]/80 max-w-xl">
            Join 950,000+ drivers who&apos;ve stopped writing their number on a piece of paper.
            Start with a single SECQRE tag — 60-day money-back guarantee.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link to="/pricing" className="btn-primary" data-testid="cta-buy">
              Get my SECQRE tag <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 rounded-lg border-2 border-[#0A0A0A] bg-transparent text-[#0A0A0A] px-6 py-3.5 font-semibold transition-all hover:bg-[#0A0A0A] hover:text-white" data-testid="cta-talk">
              Talk to our team
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
